import { ExportOutlined } from '@ant-design/icons';

import './style.css';
import useMaintenanceState from '../../../../../../../atoms/variables';
import { Button, notification } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import SystemTable from './components/SystemTable';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BypassButton from '../../helperComponents/BypassButton';
import { getOrCreateTask, updateTaskNoValidation } from '../../../../../../../helpers/apiCalls';

import useTemplateState from '../../../../../../../../Template/atoms/variables';
import { useMsal } from '@azure/msal-react';

const SystemDependency = ({ asset, phaseTitle, setAllTasks, testId, stageIndex }) => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { assetId, interconnectionId, plantId } = useParams();
  const { t } = useTranslation();
  const { setPendingApiCalls } = useTemplateState();
  const [allItems, setAllItems] = useState([]);
  const [allMandatoryApproved, setAllMandatoryApproved] = useState(false);

  const [systemTask, setSystemTask] = useState(null);

  const addSystemItems = (newItems) => {
    setAllItems((current) => {
      const itemsToAdd = newItems.filter(
        (item) => !current.find((existing) => existing._id === item._id),
      );

      return current.concat(itemsToAdd);
    });
  };

  useEffect(() => {
    fetchSystemTask();
  }, []);

  useEffect(() => {
    if (systemTask?.bypass?.bypassed) {
      setAllTasks((prev) => [
        ...prev?.filter((t) => t.test._id != `${testId}-${stageIndex}`),
        { test: { _id: `${testId}-${stageIndex}` }, report: { status: 'approved' } },
      ]);
    } else {
      if (
        allItems.length > 0 &&
        allItems.every((item) => item.status?.toLowerCase() === 'approved')
      ) {
        setAllMandatoryApproved(true);

        setAllTasks((prev) => [
          ...prev?.filter((t) => t.test._id != `${testId}-${stageIndex}`),
          { test: { _id: `${testId}-${stageIndex}` }, report: { status: 'approved' } },
        ]);
      } else {
        setAllMandatoryApproved(false);

        setAllTasks((prev) => [
          ...prev?.filter((t) => t.test._id != `${testId}-${stageIndex}`),
          { test: { _id: `${testId}-${stageIndex}` }, report: { status: 'pending' } },
        ]);
      }
    }
  }, [allItems, systemTask]);

  useEffect(() => {
    if (systemTask && !systemTask?.bypass?.bypassed) {
      if (allMandatoryApproved) {
        updateTaskNoValidation(instance, {
          _id: systemTask._id,
          status: 'Validated',
        });
      } else {
        updateTaskNoValidation(instance, {
          _id: systemTask._id,
          status: 'Pending',
        });
      }
    }
  }, [allMandatoryApproved, systemTask]);

  const fetchSystemTask = async () => {
    try {
      setPendingApiCalls((prev) => prev.concat(['getOrCreateTask']));

      const task = await getOrCreateTask(instance, {
        test: testId,
        stage: phaseTitle,
        subjectId: assetId ?? interconnectionId,
        subjectType: assetId ? 'Asset' : 'Interconnection',
        token: `${assetId ?? interconnectionId}-${phaseTitle}-SYSDEP-${stageIndex}`,
        code: 'SYSDEP',
      });
      setSystemTask(task);
    } catch (err) {
      console.log('Failed to fetch tasks', err?.message);
    } finally {
      setPendingApiCalls((prev) => prev.filter((call) => call !== 'getOrCreateTask'));
    }
  };

  return (
    <div className='systemDependency'>
      {asset.system?.length > 0 ? (
        asset?.system.map((system) => {
          return (
            <SystemTable
              systemTask={systemTask}
              system={system}
              addSystemItems={addSystemItems}
              bypassCallback={() => {
                setAllTasks((prev) => [
                  ...prev?.filter((t) => t.test._id != `${testId}-${stageIndex}`),
                  { test: { _id: `${testId}-${stageIndex}` }, report: { status: 'approved' } },
                ]);
                setSystemTask((prev) => ({
                  ...prev,
                  bypass: {
                    bypassed: true,
                  },
                }));
              }}
            />
          );
        })
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div className='systemDependencyHeader'>
            <div className='systemNameContainer'>
              <div className={'bypassedContainer'}>
                <div className={'systemName' + (systemTask?.bypass?.bypassed ? ' bypassed' : '')}>
                  {t('no_system_header')}
                </div>
                {systemTask?.bypass?.bypassed && (
                  <div className='bypassedText'>{`(${t('bypassed')})`}</div>
                )}
              </div>
              <div className='systemNavigate'>
                <BypassButton
                  systemTask={systemTask}
                  title={t('system_dependency_title')}
                  bypassCallback={() => {
                    setAllTasks((prev) => [
                      ...prev?.filter((t) => t.test._id != `${testId}-${stageIndex}`),
                      { test: { _id: `${testId}-${stageIndex}` }, report: { status: 'approved' } },
                    ]);
                    setSystemTask((prev) => ({
                      ...prev,
                      bypass: {
                        bypassed: true,
                      },
                    }));
                  }}
                />
              </div>
            </div>
          </div>
          <div className='systemContent'>
            {t('no_system_body')}
            <div style={{}}>
              <Button
                size='large'
                icon={<ExportOutlined />}
                disabled={systemTask?.bypass?.bypassed}
                style={{
                  width: 'fit-content',
                  borderColor: '#1777FF',
                  background: '#1777FF',
                  color: 'white',
                  opacity: systemTask?.bypass?.bypassed ? 0.5 : 1,
                }}
                onClick={() => {
                  navigate(`/maintenance/plants/${plantId}/systems`);
                }}
              >
                {t('systems')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemDependency;
